// API configuration
// Prod/staging: ustaw REACT_APP_API_URL (np. https://packflow.api.insolitum.ai).
// Front i API są na różnych hostach (Vercel vs Railway), więc nie ma sensownego
// fallbacku "ten sam host" — poza lokalnym devem.

// Backend produkcyjny (Railway). Używany TYLKO gdy REACT_APP_API_URL jest puste
// lub jest placeholderem — env w dashboardzie Vercela pozostaje źródłem prawdy.
const PROD_API_URL = 'https://packflow.api.insolitum.ai';

// Placeholdery typu "https://<twoj-projekt>.up.railway.app" wkompilowane z env
// nie mogą trafić do axios — traktujemy je jak brak konfiguracji.
const isUsableUrl = (v: string | undefined): v is string =>
  !!v && /^https?:\/\//.test(v.trim()) && !v.includes('<') && !v.includes('>');

const getApiUrl = (): string => {
  const fromEnv = process.env.REACT_APP_API_URL;
  if (isUsableUrl(fromEnv)) return fromEnv.trim().replace(/\/+$/, '');

  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:8083';
  }

  if (fromEnv) {
    console.warn(`[api] REACT_APP_API_URL wygląda na placeholder (${fromEnv}) — używam ${PROD_API_URL}`);
  } else {
    console.warn(`[api] REACT_APP_API_URL nie ustawione — używam ${PROD_API_URL}`);
  }
  return PROD_API_URL;
};

export const API_URL = getApiUrl();
